<template>
  <!-- 数据统计时间筛选组件 -->
  <div>
    <Tabs class="tabs" title="商户管理" />
    <div class="box">
      <div class="title">结算银行账户</div>
      <blue-title class="style">结算银行账户</blue-title>
      <div>
        <div class="info">
          <span class="marRight">账户类型</span
          ><span>{{
            bankData.bankAccountType == 'BANK_ACCOUNT_TYPE_CORPORATE' ? '对公银行账户' : '对私银行账户'
          }}</span>
        </div>
        <div class="info">
          <span class="marRight">开户名称</span><span>{{ bankData.accountName }}</span>
        </div>
        <div class="info">
          <span class="marRight">开户银行省市</span><span>{{ bankData.province }} {{ bankData.city }}</span>
        </div>
        <div class="info"><span class="marRight">门店省市</span><span>-----</span></div>
        <div class="info">
          <span class="marRight">开户银行联行号</span><span>{{ bankData.bankBranchId }}</span>
        </div>
        <div class="info">
          <span class="marRight">户开户银行全称</span><span>{{ bankData.accountBranchName }}</span>
        </div>
        <div class="info">
          <span class="marRight">银行账号</span><span>{{ bankData.accountNumber }}</span>
        </div>
      </div>
      <div class="btn">
        <el-button type="info" @click="back">返回</el-button>
        <el-button type="primary" @click="next">下一页</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { draftEcho } from '../../../../api/module/merchants';

export default {
  components: {},
  props: {},
  data() {
    return {
      bankData: {},
    };
  },
  computed: {
    uuid() {
      return this.$route.query.uuid;
    },
  },
  watch: {},
  created() {
    this.draftEcho();
  },
  methods: {
    back() {
      this.$router.push({
        path: '/merchants',
      });
    },
    next() {
      const { uuid } = this;
      this.$router.push({
        path: '/merchants/superAdminDetails',
        query: {
          uuid,
        },
      });
    },
    async draftEcho() {
      const { uuid } = this;
      const result = await draftEcho({
        uuid,
      });
      this.bankData = result.settlementBankAccountVO;
      console.log('回显所填信息', result);
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  background-color: white;
  box-sizing: border-box;
  padding: 20px;
  height: 100%;
  .title {
    font-size: 16px;
    color: #333;
    font-weight: 500;
  }
  .style {
    font-size: 12px;
    color: #333;
    font-weight: 500;
    margin: 9px 0 20px 0;
  }
  .info {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #333;
    font-weight: 500;
    height: 42px;
    border-bottom: 1px solid #e5e5e5;
  }
  .marRight {
    width: 90px;
    margin-right: 38px;
  }
  .btn {
    margin-top: 100px;
  }
}
</style>
